
(function() {
  var cards = [];

  function bindCard(card) {
    if (!card || card.dataset.yssTiltBound === 'true') return;
    card.dataset.yssTiltBound = 'true';
    card.classList.add('yss-card-tilt');

    card.addEventListener('mousemove', function(e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width;
      var y = (e.clientY - rect.top) / rect.height;

      var rotateY = (x - 0.5) * 8;
      var rotateX = (0.5 - y) * 8;

      card.style.setProperty('--yss-tilt-x', rotateX.toFixed(2) + 'deg');
      card.style.setProperty('--yss-tilt-y', rotateY.toFixed(2) + 'deg');
      card.style.setProperty('--yss-card-glow-x', (x * 100).toFixed(1) + '%');
      card.style.setProperty('--yss-card-glow-y', (y * 100).toFixed(1) + '%');
      card.style.setProperty('--yss-lift', '-6px');
    }, { passive: true });

    card.addEventListener('mouseleave', function() {
      card.style.setProperty('--yss-tilt-x', '0deg');
      card.style.setProperty('--yss-tilt-y', '0deg');
      card.style.setProperty('--yss-lift', '0');
    }, { passive: true });
  }

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    cards = Array.from(document.querySelectorAll('.yssdg-card, .yssc-card, .yss-prod-card, .yss-cat-card'));
    cards.forEach(bindCard);

    var observer = new MutationObserver(function() {
      Array.from(document.querySelectorAll('.yssdg-card, .yssc-card, .yss-prod-card, .yss-cat-card')).forEach(bindCard);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
